

















import { biHottag, windowHelper, CustomException, util } from '@tencent/ppd-base-libs';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getConfig } from './business';
import { BannerConfig } from './types';

@Component
export default class Vertical extends Vue {
  @Prop() bannerConfigUrl!: string;
  @Prop() hottag!: string;
  @Prop() type!: string;
  @Prop({ default: '8px' }) marginBottom!: string;
  @Prop({ default: '4px' }) borderRadius!: string;

  public bannerListData: BannerConfig[] = [];
  public isShow = false;
  get styleObj() {
    return {
      marginBottom: this.marginBottom,
      borderRadius: this.borderRadius,
    };
  }
  async created() {
    const [err, bannerListData] = await util.to(getConfig(this.bannerConfigUrl));
    if (err) {
      throw new CustomException(
        err,
        'GetBannerConfigException',
        `get banner config error , bannerConfigUrl ${this.bannerConfigUrl}`,
      );
    }
    this.bannerListData = bannerListData.concat(); // bannerListData;
    this.isShow = true;
  }
  /**
   * 响应banner点击
   */
  handleBannerClick(bannerJumpUrl, bannerTag) {
    biHottag(this.hottag, {
      fbannerTag: bannerTag,
    });
    windowHelper.redirect(bannerJumpUrl, 300);
  }
}
